import { FC } from 'react'
import { Item, getKontentImage } from '@lib/kontent'
import { MembershipFeaturedItem } from '@lib/kontent/models/MembershipFeaturedItem'
import { MembershipHomepage } from '@lib/kontent/models/MembershipHomepage'
import { Button, Container, OldHeading, Image } from '@gassan-ui'
import { useLoyaltyStatus } from '../hooks/use-loyalty-status'

type MembershipHomepageFeaturedItemProps = {
  item: MembershipHomepage
  modularContent: {
    [key: string]: any
  }
}

type StatusNoToFieldName = {
  [key: number]: keyof MembershipHomepage
}

const statusNoToFieldName: StatusNoToFieldName = {
  5: 'featured_item_non_member',
  4: 'featured_item_member',
  3: 'featured_item_gold',
  2: 'featured_item_platinum',
  1: 'featured_item_diamond',
}

export const MembershipHomepageFeaturedItem: FC<MembershipHomepageFeaturedItemProps> = ({
  item,
  modularContent,
}) => {
  const { membershipNo } = useLoyaltyStatus()
  const fieldName = statusNoToFieldName[membershipNo as keyof StatusNoToFieldName]
  const itemCodename = item[fieldName] ? (item[fieldName]?.value[0] as string) : null
  const featuredItem = itemCodename
    ? (modularContent[itemCodename] as Item<MembershipFeaturedItem>)
    : undefined

  if (!featuredItem) {
    return null
  }

  return (
    <Container>
      <div className="relative  flex items-center px-4 py-16">
        <Image
          className="absolute inset-0 h-full w-full"
          sources={[
            getKontentImage(featuredItem.elements.mobile_image.value[0].url, {
              width: 600,
            }),
            getKontentImage(featuredItem.elements.mobile_image.value[0].url, {
              width: 600,
            }),
            getKontentImage(featuredItem.elements.desktop_image.value[0].url, {
              width: 1000,
            }),
            getKontentImage(featuredItem.elements.desktop_image.value[0].url, {
              width: 1000,
            }),
            getKontentImage(featuredItem.elements.desktop_image.value[0].url, {
              width: 1600,
            }),
          ]}
          alt={featuredItem.elements.desktop_image.value[0].description as string}
          placeholderSrc={getKontentImage(featuredItem.elements.desktop_image.value[0].url, {
            width: 50,
          })}
        />
        <div className="relative z-[2] mx-auto flex w-full max-w-[50rem] flex-col items-center justify-center text-center">
          <OldHeading variant="h1" as="h2" mb="2" color="white">
            {featuredItem.elements.title.value}
          </OldHeading>
          <OldHeading variant="h3" as="h3" color="white">
            {featuredItem.elements.description.value}
          </OldHeading>
          <a href={featuredItem.elements.button_link.value} target="_blank" rel="noreferrer">
            <Button as="link" variant="light">
              {featuredItem.elements.button_text.value}
            </Button>
          </a>
        </div>
      </div>
    </Container>
  )
}
